export default {
  shopAddress: 'Магазин: {{- address}}',
  phone: 'Телефон:',
  copyright: '© 2018 - {{- currentYear}} - Все права защищены',
};
